import {REPORT_EXPORT_MO_DETAIL} from '../../common/constants/Reports.js'
import {useSelector} from '../../store.js'
import {showEditReportModal} from '../ReportsPage/Modals/EditReportModal.js'
import {reportOptionsByValueSelector} from '../ReportsPage/reportsPageSelectors.js'
import {showCreateMOModal} from './Modals/CreateMOModal.js'

export default function Actions() {
  const reportOptionsByValue = useSelector(reportOptionsByValueSelector)

  return (
    <>
      <li className="inline-block v-align-middle fs-n0 divider--left">
        <button
          className="btn btn--action v-align-base"
          type="button"
          onClick={() => showCreateMOModal()}
        >
          Initiate a MFG Order
        </button>
      </li>
      {reportOptionsByValue[REPORT_EXPORT_MO_DETAIL] && (
        <li className="inline-block v-align-middle fs-n0 margin-left-10">
          <button
            className="btn btn--action v-align-base"
            type="button"
            onClick={() =>
              showEditReportModal({
                reportType: REPORT_EXPORT_MO_DETAIL,
                singleRun: true,
              })
            }
          >
            Export MFG Orders
          </button>
        </li>
      )}
    </>
  )
}
